import AnalyticsScreen from "../analytics/components/AnalyticsScreen";

const MistakeBookPracticeSetAnalyticsPage = () => {
  return <AnalyticsScreen />;
};

export default MistakeBookPracticeSetAnalyticsPage;
